// extracted by mini-css-extract-plugin
module.exports = {"root":"Ratings-module--root--3tLiC","mock":"Ratings-module--mock--25els"};